import { mapObjects } from "services";

export const kdsListResponse = {
  id: { key: "kdsId" },
  name: { key: "name" },
  outletId: { key: "outletId" },
  outletName: { key: "outletName" },
  type: { key: "type" },
  status: { key: "status" },
  isDefault: { key: "isDefault" },
};

export const kdsListFilterRequest = {
  venueId: { key: "venueId" },
  page: { key: "page" },
  pageSize: { key: "pageSize" },
  searchKey: { key: "searchKey" },
  outletId: { key: "outletId" },
  status: { key: "status" },
};

export const kdsRequest = {
  venueId: { key: "venueId" },
  outletId: { key: "outletId" },
  name: { key: "name" },
  type: { key: "type" },
  status: { key: "status" },
  isDefault: { key: "isDefault" },
};

export const kdsDetailResponse = {
  id: { key: "kdsId" },
  name: { key: "name" },
  outletId: { key: "outletId" },
  type: { key: "type" },
  status: { key: "status" },
  isDefault: { key: "isDefault" },
  categories: {
    transform: ({ src }) => {
      const categoryIds = src.categoryIds || [];
      return mapObjects(categoryIds, {
        value: {
          transform: ({ src }) => src,
        },
        text: {
          transform: ({ src }) => `#${src}`,
        },
      });
    },
  },
  products: {
    transform: ({ src }) => (src.productIds || []).map(String),
  },
  skus: {
    transform: ({ src }) => {
      const skuIds = src.skuIds || [];
      return mapObjects(skuIds, {
        value: {
          transform: ({ src }) => src,
        },
        text: {
          transform: ({ src }) => `#${src}`,
        },
      });
    },
  },
};

export const kdsMappingRequest = {
  category_ids: {
    transform: ({ src }) => (src.categories || []).map((x) => Number(x.value)),
  },
  product_ids: {
    transform: ({ src }) => (src.products || []).map(Number),
  },
  sku_ids: {
    transform: ({ src }) => (src.skus || []).map((x) => Number(x.value)),
  },
};

